import { render, staticRenderFns } from "./handicap.vue?vue&type=template&id=878ef6da"
import script from "./handicap.vue?vue&type=script&lang=js"
export * from "./handicap.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports